import { Skeleton } from 'antd';

const Loading: React.FC = () => (
  <Skeleton style={{ margin: '20px 20px', height: '60vh' }} active />
);

export default Loading;
